import axios, { AxiosError } from "axios";

// Support both names: VITE_API_BASE_URL (code) and VITE_API_URL (deploy / .env.example)
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_API_URL ||
  "/api";

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth-storage");
    if (token) {
      try {
        const authData = JSON.parse(token);
        if (authData.state?.token) {
          config.headers.Authorization = `Bearer ${authData.state.token}`;
        }
      } catch (error) {
        console.error("Error parsing auth token:", error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // 2FA grace period expired (Story 10-5-10): redirect to forced 2FA setup page
    if (error.response?.status === 403 && error.response?.headers["x-2fa-required"] === "true") {
      window.location.href = "/setup-2fa-required";
      return Promise.reject(error);
    }

    // Don't redirect on 401 if we're already on the login page (prevents redirect loop)
    // Also don't redirect on 429 (rate limit) or 403 (forbidden) errors
    if (error.response?.status === 401) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      const isLoginPage =
        path === "/login" ||
        path === "/portal/login" ||
        path === "/portal/request-access";

      // Only redirect if not on login page (to avoid clearing login errors)
      if (!isLoginPage) {
        // Token expired or invalid - clear auth
        localStorage.removeItem("auth-storage");

        // Show user-friendly message
        alert("Session expired, please log in again");

        // Redirect to appropriate login based on current path (Story 7-1)
        window.location.href = path.startsWith("/portal") ? "/portal/login" : "/login";
      }
    }
    // Let 429 and 403 errors pass through without redirecting
    return Promise.reject(error);
  }
);

export default api;
